<template>
    <v-card class="confirm-info" dark elevation="0">
        <header class="confirm-info__header">
            <span class="confirm-info__eyebrow">Seed stock</span>
            <h2>Confirm contact & address</h2>
            <p>Review the shipping details for your seed stock shipment.</p>
        </header>
        <div class="confirm-info__body">
            <info-input
                :info-type="'Shipping'"
                :value="{ contact: contact.shipping, address: address.shipping }"
            ></info-input>
        </div>
        <v-card-actions class="confirm-info__actions">
            <v-btn class="confirm-info__cancel" elevation="0" text @click="$emit('cancel')">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
                class="confirm-info__confirm"
                color="#db5120"
                dark
                elevation="0"
                :disabled="!formIsValid"
                @click="$emit('confirmed', { contact: contact.shipping, address: address.shipping })"
                >Confirm</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
import formRules from '@/utils/form_rules'
import InfoInput from './info_input.vue'
import gql from 'graphql-tag'

export default {
    name: 'ConfirmInfo',
    components: { InfoInput },
    apollo: {
        querySMCustomer: {
            query: gql`
                query QuerySMCustomer($customerId: String!) {
                    querySMCustomer(customerId: $customerId) {
                        shipping {
                            address {
                                APO
                                company
                                line1
                                line2
                                city
                                state
                                country
                                postalCode
                                international
                            }
                            contact {
                                firstName
                                lastName
                                fullName
                                email
                                phone
                                company
                                position
                            }
                        }
                        smConfirmed
                    }
                }
            `,
            skip() {
                return !this.$auth.user.org.branchId
            },
            variables() {
                return {
                    customerId: this.$auth.user.org.branchId
                }
            },
            update(data) {
                const customer = data.querySMCustomer
                if (customer && customer.shipping) {
                    if (customer.contact) {
                        this.contact.shipping = {
                            company: customer.contact.company || ``,
                            firstName: customer.contact.firstName || ``,
                            lastName: customer.contact.lastName || ``,
                            email: customer.contact.email || ``,
                            phone: customer.contact.phone || ``,
                            phoneCountryCode: ``
                        }
                    }
                    if (customer.address) {
                        this.address.shipping = {
                            country: customer.address.country || ``,
                            line1: customer.address.line1 || ``,
                            line2: customer.address.line2 || ``,
                            city: customer.address.city || ``,
                            state: customer.address.state || ``,
                            postalCode: customer.address.postalCode || ``
                        }
                    }
                }
            }
        }
    },
    data() {
        return {
            formRules,
            phoneInput: ``,
            contact: {
                billing: {
                    company: ``,
                    firstName: ``,
                    lastName: ``,
                    email: ``,
                    phone: ``,
                    phoneCountryCode: ``
                },
                shipping: {
                    company: ``,
                    firstName: ``,
                    lastName: ``,
                    email: ``,
                    phone: ``,
                    phoneCountryCode: ``
                }
            },
            address: {
                billing: {
                    line1: ``,
                    line2: ``,
                    city: ``,
                    state: ``,
                    postalCode: ``
                },
                shipping: {
                    line1: ``,
                    line2: ``,
                    city: ``,
                    state: ``,
                    postalCode: ``
                }
            },
            formInput: {
                company: ``,
                firstName: ``,
                lastName: ``,
                email: ``,
                phone: ``,
                phoneCountryCode: ``
            }
        }
    },
    computed: {
        formIsValid() {
            const contact =
                !!this.contact.shipping.company &&
                !!this.contact.shipping.firstName &&
                !!this.contact.shipping.lastName &&
                !!this.contact.shipping.email &&
                !!this.contact.shipping.phone
            const address =
                !!this.address.shipping.line1 &&
                !!this.address.shipping.city &&
                !!this.address.shipping.state &&
                !!this.address.shipping.postalCode
            return contact && address
        },
        oidcBilling() {
            return this.$auth.user.address ? this.$auth.user.address.billing : {}
        },
        oidcShipping() {
            return this.$auth.user.address ? this.$auth.user.address.shipping : {}
        }
    },
    methods: {
        assignPhone(a) {
            // eslint-disable-next-line no-unused-vars
            const [input, phoneObject] = a
            this.phoneValid = phoneObject.nationalNumber ? !!phoneObject.valid : true
            this.formInput.phone = phoneObject.nationalNumber
            this.formInput.phoneCountryCode = phoneObject.countryCode
        }
    }
}
</script>

<style scoped>
.confirm-info.v-card {
    display: flex;
    max-height: calc(100vh - 48px);
    max-height: calc(100dvh - 48px);
    flex-direction: column;
    overflow: hidden;
    color: #f2f4fa;
    background: #282b33;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    font-family: 'Inter Tight', 'Roboto', sans-serif;
}
.confirm-info__header {
    flex-shrink: 0;
    padding: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.09);
}
.confirm-info__eyebrow {
    color: #f0784c;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1.2px;
    text-transform: uppercase;
}
.confirm-info__header h2 {
    margin: 5px 0 8px;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: -0.5px;
    line-height: 1.3;
}
.confirm-info__header p {
    margin: 0;
    color: #b9bfcc;
    font-size: 12px;
    line-height: 1.5;
}
.confirm-info__body {
    min-height: 0;
    padding: 20px;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-color: #f0784c #22252d;
    scrollbar-width: thin;
}
.confirm-info__actions {
    flex-shrink: 0;
    gap: 12px;
    padding: 16px 24px;
    background: #22252d;
    border-top: 1px solid rgba(255, 255, 255, 0.09);
}
.confirm-info__actions .v-btn {
    min-height: 40px;
    border-radius: 7px;
    font-family: inherit;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
}
.confirm-info__cancel.v-btn {
    color: #c7cbd4;
}
.confirm-info__confirm.v-btn:not(.v-btn--disabled):hover {
    background-color: #b84420 !important;
}
.confirm-info__actions .v-btn:focus-visible {
    outline: 2px solid #f0784c;
    outline-offset: 3px;
}
@media (max-width: 599px) {
    .confirm-info.v-card {
        max-height: 100vh;
        max-height: 100dvh;
    }
    .confirm-info__header {
        padding: 20px 16px;
    }
    .confirm-info__header h2 {
        font-size: 20px;
    }
    .confirm-info__body {
        padding: 16px 12px;
    }
    .confirm-info__actions {
        padding: 16px;
    }
}
</style>
